export enum Sorting {
    None,
    Ascending,
    Descending
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/domain/occasions/sorting/Sorting.ts